module.exports = "/static/assets/2008ef9a82bcbaa0dd5fb3fa121c4afc.png";